var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.errors)?_c('div',{staticClass:"alert alert-danger display-errors",attrs:{"role":"alert"}},[_c('v-icon',{staticClass:"display-errors__icon",attrs:{"size":"sm"}},[_vm._v("circle-alert")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.errors.message))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }